import React, { useEffect, useState } from 'react';
import { Box, Button, Group, Paper, Text } from '@mantine/core';
import {
    ANALYTICS_CONSENT_STORAGE_KEY,
    grantAnalyticsConsent,
} from '../utils/analyticsConsent';
import { optInAnalytics, optOutAnalytics, trackConsentChoice } from '../utils/analytics';

export function AnalyticsConsentBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            setVisible(localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY) === null);
        } catch {
            setVisible(true);
        }
    }, []);

    const onYes = () => {
        try {
            localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, 'yes');
        } catch {
            /* ignore */
        }
        grantAnalyticsConsent();
        optInAnalytics();
        trackConsentChoice(true);
        setVisible(false);
    };

    const onNo = () => {
        try {
            localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, 'no');
        } catch {
            /* ignore */
        }
        optOutAnalytics();
        trackConsentChoice(false);
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <Box
            pos="fixed"
            bottom={0}
            left={0}
            right={0}
            p="md"
            style={{ zIndex: 10000 }}
        >
            <Paper shadow="md" p="md" radius="md" withBorder mx="auto" maw={720}>
                <Group justify="space-between" align="flex-start" wrap="wrap" gap="sm">
                    <Text size="sm" maw={480} style={{ flex: '1 1 220px' }}>
                        By visiting this site, you agree to our data collection policy, as described in our <a href="/privacy">Privacy Policy</a>.
                    </Text>
                    <Group gap="xs" wrap="nowrap">
                        <Button variant="white" size="sm" onClick={onNo}>
                            No
                        </Button>
                        <Button variant="filled" color="primary" size="sm" onClick={onYes}>
                            Yes
                        </Button>
                    </Group>
                </Group>
            </Paper>
        </Box>
    );
}
